import React from "react";
// ANT DESIGN COMPONENTS
import { Tag, Tooltip } from "antd";
// FONT AWESOME LIBRARY
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// FLATBUFFERS
import { CognitoUserStatus } from "../../../flatbuffers/generated/archive/cognito-user-status";
import { cognitoUserStatusLabel } from "../../../flatbuffers/display/enums";
// STATUS METADATA
import { COGNITO_STATUS_META } from "../../../components/users/cognitoStatusMeta";

interface TableColumnCognitoStatusProps {
  /** The overlaid `cognito_status` discriminant. */
  text: CognitoUserStatus | number | null | undefined;
}

/** The live Cognito account state for one user row. */
function TableColumnCognitoStatus({ text }: TableColumnCognitoStatusProps) {
  if (text === null || text === undefined) return null;

  const status = text as CognitoUserStatus;
  const meta = COGNITO_STATUS_META[status];
  if (!meta) return null;

  return (
    <Tooltip title={meta.description}>
      <Tag
        color={meta.color}
        icon={<FontAwesomeIcon icon={meta.icon} className="generalStyles__mrFix" />}
        className="drawer__tag generalStyles__textCenter"
      >
        {cognitoUserStatusLabel(status)}
      </Tag>
    </Tooltip>
  );
}

export default TableColumnCognitoStatus;
